// import { CSS_UTILITY } from './resources';
// import { guid } from './guid';

const assignFilteredObject = (element: HTMLElement, object: Record<string, any>) => {
  Object.assign(element, Object.fromEntries(Object.entries(object).filter(([, value]) => !!value)));
};

/** Determines if element contains text */
const hasText = (element: HTMLElement): boolean => element.textContent.trim() !== '';

// /**
//  * This helper will guarantee an ID on the provided element.
//  *
//  * If it already has an ID, it will be preserved, otherwise a unique one will be generated and assigned.
//  *
//  * @returns {string} The element's ID.
//  */
// const ensureId = (element: Element): string =>
//   element ? (element.id = element.id || `${element.tagName.toLowerCase()}-${guid()}`) : '';

// const nodeListToArray = <T extends Element>(nodeList: HTMLCollectionOf<T> | NodeListOf<T> | T[]): T[] => [
//   ...nodeList
// ];

type Direction = 'ltr' | 'rtl';
// type Theme = 'dark' | 'light';

// const getThemeName = (element: HTMLElement): Theme =>
//   closestElementCrossShadowBoundary(element, `.${CSS_UTILITY.darkTheme}`) ? 'dark' : 'light';

const getElementDir = (element: HTMLElement): Direction =>
  (closestElementCrossShadowBoundary(element, '[dir]')?.getAttribute('dir') as Direction) || 'ltr';

// const getElementProp = (element: Element, prop: string, fallbackValue: any): any => {
//   const closest = element.closest(`[${prop}]`);

//   return closest ? closest.getAttribute(prop) : fallbackValue;
// };

const getRootNode = (element: Element): Document | ShadowRoot => element.getRootNode() as Document | ShadowRoot;

const getHost = (root: Document | ShadowRoot): Element | null => (root as ShadowRoot).host || null;

// // Queries an element's rootNode and any ancestor rootNodes.
// // based on https://stackoverflow.com/q/54520554/194216
// const queryElementsRoots = <T extends Element = Element>(element: Element, selector: string): T[] => {
//   // Gets the rootNode and any ancestor rootNodes (shadowRoot or document) of an element and queries them for a selector.
//   const queryFromAll = <T extends Element = Element>(element: Element, allResults: T[]): T[] => {
//     if (!element) return allResults;

//     if ((element as Slottable).assignedSlot) element = (element as Slottable).assignedSlot;

//     const rootNode = getRootNode(element);

//     const results = [...rootNode.querySelectorAll(selector)] as T[];

//     const uniqueResults = results.filter((result) => !allResults.includes(result));

//     allResults = [...allResults, ...uniqueResults];

//     const host = getHost(rootNode);

//     return host ? queryFromAll(host, allResults) : allResults;
//   };

//   return queryFromAll(element, []);
// };

// Queries element's rootNode and ancestor rootNodes.
// Based on https://stackoverflow.com/q/54520554/194216
const queryElementRoots = <T extends Element = Element>(element: Element, selector: string): T | null => {
  // Gets the rootNode and any ancestor rootNodes (shadowRoot or document) of an element and queries them for a selector.
  const queryFrom = <T extends Element = Element>(element: Element): T | null => {
    if (!element) return null;

    if ((element as Slottable).assignedSlot) element = (element as Slottable).assignedSlot;

    const rootNode = getRootNode(element);
    const found = rootNode.querySelector(selector) as T;
    const host = getHost(rootNode);

    return found ? found : host ? queryFrom(host) : null;
  };

  return queryFrom(element);
};

const closestElementCrossShadowBoundary = <T extends Element = Element>(
  element: Element,
  selector: string
): T | null => {
  // based on https://stackoverflow.com/q/54520554/194216
  const closestFrom = <T extends Element = Element>(element: Element): T | null =>
    element ? element.closest(selector) || closestFrom(getHost(getRootNode(element))) : null;

  return closestFrom(element);
};

// interface AbdsFocusableElement extends HTMLElement {
//   setFocus?: () => Promise<void>;
// }

// const isAbdsFocusable = (element: AbdsFocusableElement): boolean => typeof element?.setFocus === 'function';

// const focusElement = async (element: AbdsFocusableElement): Promise<void> => {
//   if (!element) return;

//   return isAbdsFocusable(element) ? element.setFocus() : element.focus();
// };

// interface GetSlottedOptions {
//   all?: boolean;
//   direct?: boolean;
//   selector?: string;
// }

// function getSlotted<T extends Element = Element>(
//   element: Element,
//   slotName: string,
//   options: GetSlottedOptions & { all: true }
// ): T[];

// function getSlotted<T extends Element = Element>(
//   element: Element,
//   slotName: string,
//   options?: GetSlottedOptions
// ): T | null;

// function getSlotted<T extends Element = Element>(
//   element: Element,
//   slotName: string,
//   options?: GetSlottedOptions
// ): (T | null) | T[] {
//   return options?.all
//     ? queryMultiple<T>(element, `[slot="${slotName}"]`, options)
//     : querySingle<T>(element, `[slot="${slotName}"]`, options);
// }

// const queryMultiple = <T extends Element = Element>(
//   element: Element,
//   slotSelector: string,
//   { direct, selector }: GetSlottedOptions
// ): T[] => {
//   let matches = [...element.querySelectorAll<T>(slotSelector)];
//   matches = direct === false ? matches : matches.filter((el) => el.parentElement === element);

//   return selector
//     ? matches
//         .map((item) => Array.from(item.querySelectorAll<T>(selector)))
//         .reduce((previousValue, currentValue) => [...previousValue, ...currentValue], [])
//         .filter((match) => !!match)
//     : matches;
// };

// const querySingle = <T extends Element = Element>(
//   element: Element,
//   slotSelector: string,
//   options?: GetSlottedOptions
// ): T | null => {
//   let match = element.querySelector<T>(slotSelector);
//   match = options && options.direct === false ? match : match?.parentElement === element ? match : null;

//   const selector = options?.selector;

//   return selector ? match.querySelector<T>(selector) : match;
// };

// const filterDirectChildren = <T extends Element>(element: Element, selector: string): T[] =>
//   [...element.children].filter((child): child is T => child.matches(selector));

// const hasLabel(labelEl: HTMLCalciteLabelElement, element: HTMLElement): boolean => labelEl.contains(element);

// // set a default icon from a defined set or allow an override with an icon name string
// const setRequestedIcon = (iconObject: Record<string, string>, iconValue: string, matchedValue: string): string =>
//   typeof iconValue === 'string' && iconValue ? iconValue : typeof iconValue === 'string' && iconObject[matchedValue];

// const intersects = (rect1: DOMRect, rect2: DOMRect): boolean =>
//   (rect1.right < rect2.left ||  rect1.left > rect2.right || rect1.bottom < rect2.top ||  rect1.top > rect2.bottom);

const setValidElementAttributes = (element: HTMLElement, attributes: Record<string, any>) => {
  Object.entries(attributes)
    .filter(([, value]) => !!value)
    .forEach(([property, value]) => {
      element.setAttribute(property, value);
    });
};

export {
  assignFilteredObject,
  closestElementCrossShadowBoundary,
  getElementDir,
  getHost,
  getRootNode,
  hasText,
  queryElementRoots,
  setValidElementAttributes,
};
